var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionsMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.82857C0 1.27846 1.23353 0 2.78182 0H22.4182C23.9665 0 25.2 1.27846 25.2 2.82857V9C25.2 9.33132 24.9313 9.6 24.6 9.6C24.2687 9.6 24 9.33132 24 9V2.82857C24 1.91708 23.2799 1.2 22.4182 1.2H2.78182C1.92013 1.2 1.2 1.91708 1.2 2.82857V13.9715C1.2 14.8829 1.92013 15.6 2.78182 15.6H11.4C11.7313 15.6 12 15.8687 12 16.2C12 16.5313 11.7313 16.8 11.4 16.8H2.78182C1.23353 16.8 0 15.5215 0 13.9715V2.82857Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.19961C0 3.86824 0.26863 3.59961 0.6 3.59961H24.6C24.9313 3.59961 25.2 3.86824 25.2 4.19961C25.2 4.53098 24.9313 4.79961 24.6 4.79961H0.6C0.26863 4.79961 0 4.53098 0 4.19961Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 10.1996C2.3999 9.86829 2.66853 9.59961 2.9999 9.59961H5.3999C5.73127 9.59961 5.9999 9.86829 5.9999 10.1996C5.9999 10.5309 5.73127 10.7996 5.3999 10.7996H2.9999C2.66853 10.7996 2.3999 10.5309 2.3999 10.1996Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 13.1996C2.3999 12.8683 2.66853 12.5996 2.9999 12.5996H7.7999C8.13127 12.5996 8.3999 12.8683 8.3999 13.1996C8.3999 13.5309 8.13127 13.7996 7.7999 13.7996H2.9999C2.66853 13.7996 2.3999 13.5309 2.3999 13.1996Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9999 11.9998C18.0175 11.9998 15.5999 14.4174 15.5999 17.3998C15.5999 20.3822 18.0175 22.7998 20.9999 22.7998C23.9823 22.7998 26.3999 20.3822 26.3999 17.3998C26.3999 14.4174 23.9823 11.9998 20.9999 11.9998ZM14.3999 17.3998C14.3999 13.7547 17.3548 10.7998 20.9999 10.7998C24.645 10.7998 27.5999 13.7547 27.5999 17.3998C27.5999 21.0449 24.645 23.9998 20.9999 23.9998C17.3548 23.9998 14.3999 21.0449 14.3999 17.3998Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9758 16.3759C23.2101 16.1416 23.5901 16.1416 23.8244 16.3759C24.0587 16.6102 24.0587 16.9902 23.8244 17.2245L21.4244 19.6245C21.1901 19.8588 20.8101 19.8588 20.5758 19.6245L18.7758 17.8245C18.5415 17.5902 18.5415 17.2102 18.7758 16.9759C19.0101 16.7416 19.3901 16.7416 19.6244 16.9759L21.0001 18.3517L22.9758 16.3759Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsMenuIcon);
export default __webpack_public_path__ + "static/media/transactions_menu_icon.0e8c4e7f57107d523ca9dfaad1b3188b.svg";
export { ForwardRef as ReactComponent };